@if (pageReady) {
  <main class="gs-page">
    <div class="stop-service-container">
      <app-page-header [headerData]="pageHeader"></app-page-header>
      <div class="gs-content-container">
        <div class="notification-container">
          <app-notification [pageName]="pageName"></app-notification>
        </div>
        @if (isMove) {
          <app-ssm-stepper [process]="process" [step]="step"></app-ssm-stepper>
        }
        <div class="stop-form-container">
          <div class="header-section">
            <h2>{{ pageLabels.stopServiceHeader }}</h2>
            @if (isMultiSA) {
              <h2>{{ this.multiSAAddr.address1 }} {{ this.multiSAAddr.address2 }}</h2>
            }
            <p>{{ pageLabels.leadText }}</p>
          </div>
          @if (!hasEmail) {
            <div class="email-form">
              <h2>{{ pageLabels.emailHeader }}</h2>
              <app-email-form [emailData]="emailFormData"></app-email-form>
              <p class="email-disclaimer">{{ pageLabels.emailDisclaimer }}</p>
            </div>
          }
          <form [formGroup]="stopServiceForm">
            <p>{{ pageLabels.selectDateText }}</p>
            <mat-radio-group
              class="gs-radio-button"
              color="primary"
              formControlName="DateOption"
              aria-labelledby="dateOptionRequiredError"
            >
              <mat-radio-button value="first" class="stop-radio">{{
                pageLabels.firstAvailableOption
              }}</mat-radio-button>
              <mat-radio-button value="choose" class="stop-radio">{{ pageLabels.chooseOption }}</mat-radio-button>
              @if (
                stopServiceForm.get("DateOption")?.hasError("required") && stopServiceForm.get("DateOption")?.touched
              ) {
                <mat-error id="dateOptionRequiredError">{{ pageLabels.optionRequiredText }}</mat-error>
              }
            </mat-radio-group>
            @if (stopServiceForm.get("DateOption")?.value === "choose") {
              <div class="stop-calendar-container">
                <mat-form-field appearance="outline" color="primary" class="stop-calendar stop-input">
                  <mat-label>{{ pageLabels.selectDateLabel }}</mat-label>
                  <input
                    matInput
                    [matDatepickerFilter]="dateFilter"
                    [matDatepicker]="picker"
                    placeholder="MM/DD/YYYY"
                    formControlName="Date"
                    [min]="startDate"
                    [max]="maxDate"
                    aria-labelledby="dateRequired invalidDateError"
                    (blur)="validatePaymentDateOnBlur($event)"
                    (dateInput)="validatePaymentDateOnCalednarChange($event)"
                    (dateChange)="validatePaymentDateOnCalednarChange($event)"
                  />
                  <mat-datepicker-toggle matIconSuffix [for]="picker"></mat-datepicker-toggle>
                  <mat-datepicker #picker (opened)="onDatepickerOpened(picker)" (closed)="onDatepickerClosed()">
                  </mat-datepicker>
                  @if (stopServiceForm.get("Date")?.hasError("required")) {
                    <mat-error id="dateRequired">{{ pageLabels.dateRequiredText }}</mat-error>
                  }
                  @if (
                    !stopServiceForm.get("Date")?.valid && !stopServiceForm.get("Date")?.hasError("aglPassThrough")
                  ) {
                    <mat-error id="invalidDateError">{{ pageLabels.invalidDateError }}</mat-error>
                  }
                </mat-form-field>
              </div>
            }
            <mat-divider></mat-divider>
            <mat-form-field class="stop-input" appearance="outline" color="primary">
              <mat-label>{{ pageLabels.selectInstructionsLabel }}</mat-label>
              <mat-select formControlName="Instructions" aria-labelledby="instructionsRequiredError">
                <mat-option class="stop-option" value="none">
                  {{ pageLabels.noneOption }}
                </mat-option>
                <mat-option class="stop-option" value="gate">
                  {{ pageLabels.gateOption }}
                </mat-option>
                <mat-option class="stop-option" value="meter">
                  {{ pageLabels.meterOption }}
                </mat-option>
                <mat-option class="stop-option" value="pet">
                  {{ pageLabels.petOption }}
                </mat-option>
                <mat-option class="stop-option" value="other">
                  {{ pageLabels.otherOption }}
                </mat-option>
              </mat-select>
              @if (stopServiceForm.get("Instructions")?.hasError("required")) {
                <mat-error id="instructionsRequiredError">{{ pageLabels.instructionsRequiredText }}</mat-error>
              }
            </mat-form-field>
            @if (
              stopServiceForm.get("Instructions")?.value === "gate" ||
              stopServiceForm.get("Instructions")?.value === "other"
            ) {
              <mat-form-field class="stop-input" appearance="outline" color="primary">
                <mat-label id="commentsLabel">{{ pageLabels.commentsLabel }}</mat-label>
                <textarea
                  matInput
                  formControlName="Comments"
                  aria-labelledby="commentsLabel"
                  aria-describedby="CommentsRequiredError CommentsCharacterError"
                  maxlength="256"
                ></textarea>
                @if (stopServiceForm.get("Comments")?.hasError("required")) {
                  <mat-error id="CommentsRequiredError">{{ pageLabels.commentsRequiredText }}</mat-error>
                }
                @if (stopServiceForm.get("Comments")?.hasError("invalidCharacters")) {
                  <mat-error id="CommentsCharacterError">{{ pageLabels.noSpecialCharactersText }}</mat-error>
                }
              </mat-form-field>
            }
            @if (!isMove) {
              <mat-form-field class="stop-input" appearance="outline" color="primary">
                <mat-label>{{ pageLabels.reasonLabel }}</mat-label>
                <mat-select formControlName="Reason" aria-labelledby="ReasonRequiredError">
                  <mat-option class="stop-option" value="Moving">
                    {{ pageLabels.movingOption }}
                  </mat-option>
                  <mat-option class="stop-option" value="Renovation/Demo">
                    {{ pageLabels.renoOption }}
                  </mat-option>
                  <mat-option class="stop-option" value="Landlord">
                    {{ pageLabels.landlordOption }}
                  </mat-option>
                  <mat-option class="stop-option" value="Going out of Business">
                    {{ pageLabels.businessOption }}
                  </mat-option>
                  <mat-option class="stop-option" value="Seasonal">
                    {{ pageLabels.seasonalOption }}
                  </mat-option>
                </mat-select>
                @if (stopServiceForm.get("Reason")?.hasError("required")) {
                  <mat-error id="ReasonRequiredError">{{ pageLabels.reasonRequiredText }}</mat-error>
                }
              </mat-form-field>
            }
            <div class="mailing-address-container">
              <h2>{{ pageLabels.forwardingAddressHeader }}</h2>
              <p>{{ pageLabels.currentAddressText }}</p>
              <p>{{ currentAddress.Address1 | titlecase }}</p>
              <p>{{ currentAddress.City }}, {{ currentAddress.State }} {{ currentAddress.PostalCode }}</p>
              @if (!changeMailingAddress) {
                <button
                  type="button"
                  class="gs-button-link"
                  tabindex="0"
                  role="link"
                  data-cy="link-stop-service-change-mailing-address"
                  (click)="toggleMailingAddressForm()"
                  (keydown.enter)="toggleMailingAddressForm()"
                  (keydown.space)="toggleMailingAddressForm($event)"
                >
                  {{ pageLabels.changeLinkText }}
                </button>
              }
              @if (changeMailingAddress) {
                <div class="mailing-address-form-container">
                  <mat-divider></mat-divider>
                  <app-mailing-address
                    [mailingAddressData]="mailingAddressFormData"
                    [unverifiedAddress]="unverifiedAddress"
                    (dataEmitter)="unverifiedAddressData($event)"
                  ></app-mailing-address>
                  <button
                    type="button"
                    class="gs-button-link"
                    tabindex="0"
                    role="link"
                    data-cy="link-stop-service-cancel-change-mailing-address"
                    (click)="toggleMailingAddressForm()"
                    (keydown.enter)="toggleMailingAddressForm()"
                    (keydown.space)="toggleMailingAddressForm($event)"
                  >
                    {{ pageLabels.cancelChangeText }}
                  </button>
                </div>
              }
            </div>
            <div class="stop-button-container">
              @if (!isMove) {
                <button
                  id="stop-service-submit"
                  class="gs-form-button-primary"
                  mat-flat-button
                  color="primary"
                  (click)="handleSubmitButtonPress()"
                >
                  {{ pageLabels.submitButtonText }}
                </button>
              } @else {
                <button
                  id="stop-service-submit"
                  class="gs-form-button-primary"
                  mat-flat-button
                  color="primary"
                  (click)="handleSubmitButtonPress()"
                >
                  {{ pageLabels.nextButtonText }}
                </button>
              }
            </div>
          </form>
        </div>
      </div>
    </div>
  </main>
}
